(() => {
  function addControls(slider, viewport, dots) {
    const template = document.querySelector('[data-lp-slider-controls]');
    if (!template || dots.length < 2) return;
    const row = document.createElement('div');
    row.className = 'kion-lp-slider-controls';
    const pagination = dots[0].parentElement;
    const controls = template.content.cloneNode(true);
    const previous = controls.querySelector('.kion-lp-slider-arrow--previous');
    const next = controls.querySelector('.kion-lp-slider-arrow--next');
    pagination.before(row);
    row.append(previous, pagination, next);
    const visible = () => dots.filter(dot => !dot.hidden);
    const current = () => visible().findIndex(dot => dot.getAttribute('aria-current') === 'true');
    const sync = () => {
      const active = current();
      previous.disabled = active <= 0;
      next.disabled = active >= visible().length - 1;
    };
    previous.addEventListener('click', () => visible()[Math.max(0, current() - 1)]?.click());
    next.addEventListener('click', () => visible()[Math.min(visible().length - 1, current() + 1)]?.click());
    const observer = new MutationObserver(sync);
    dots.forEach(dot => observer.observe(dot, {attributes: true, attributeFilter: ['aria-current', 'hidden']}));
    sync();
    viewport.addEventListener('dragstart', event => event.preventDefault());
    document.addEventListener('shopify:section:unload', event => {
      if (event.target.contains(slider)) observer.disconnect();
    });
  }

  function syncOfferButtons(root) {
    const discountCode = new URLSearchParams(window.location.search).get('discount');
    const hasDiscount = Boolean(discountCode && discountCode.trim());
    root.querySelectorAll('.kion-affiliate-shogun .lp-button[href="#buy"]').forEach(button => {
      if (button.dataset.lpOfferLabel === undefined) button.dataset.lpOfferLabel = button.textContent;
      button.textContent = hasDiscount
        ? button.dataset.lpOfferLabel.replace(/\b10\s*%/g, '20%')
        : button.dataset.lpOfferLabel;
    });
  }

  function init(root = document) {
    if (!document.querySelector('.kion-affiliate-shogun')) return;
    syncOfferButtons(root);
    root.querySelectorAll('[data-kion-home-amino-slider]').forEach(slider => {
      if (slider.dataset.lpControlsReady) return;
      const viewport = slider.querySelector('[data-slider-viewport]');
      const dots = Array.from(slider.querySelectorAll('[data-slide-index]'));
      if (!viewport || !dots.length) return;
      slider.dataset.lpControlsReady = 'true';
      addControls(slider, viewport, dots);
    });
    root.querySelectorAll('[data-lp-facts]').forEach(gallery => {
      if (gallery.dataset.initialized) return;
      const viewport = gallery.querySelector('[data-lp-facts-viewport]');
      const track = gallery.querySelector('[data-lp-facts-track]');
      const dots = Array.from(gallery.querySelectorAll('[data-lp-facts-index]'));
      if (!viewport || !track || !dots.length) return;
      gallery.dataset.initialized = 'true';
      let index = 0;
      const position = () => {
        const transform = getComputedStyle(track).transform;
        return transform === 'none' ? -index * viewport.clientWidth : new DOMMatrixReadOnly(transform).m41;
      };
      const goTo = (next, animate = true) => {
        const from = position();
        index = Math.max(0, Math.min(next, dots.length - 1));
        const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        const target = -index * viewport.clientWidth;
        track.style.transition = 'none';
        dots.forEach((dot, i) => dot.setAttribute('aria-current', String(i === index)));
        track.style.transform = `translate3d(${from}px,0,0)`;
        if (animate && !reducedMotion && Math.abs(target - from) >= 0.5) {
          track.getBoundingClientRect();
          track.style.transition = 'transform 220ms cubic-bezier(.22,.61,.36,1)';
        }
        track.style.transform = `translate3d(-${index * 100}%,0,0)`;
      };
      dots.forEach((dot, i) => dot.addEventListener('click', () => goTo(i)));
      gallery.addEventListener('keydown', event => {
        if (event.key !== 'ArrowRight' && event.key !== 'ArrowLeft') return;
        event.preventDefault();
        goTo(index + (event.key === 'ArrowRight' ? 1 : -1));
      });
      addControls(gallery, viewport, dots);
      window.addEventListener('resize', () => goTo(index, false));
      goTo(0, false);
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init());
  else init();
  document.addEventListener('shopify:section:load', event => init(event.target));
  window.addEventListener('popstate', () => syncOfferButtons(document));
})();
